import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetUnderwritingAdjustmentByClientId = async (Id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_UNDERWRITING_ADJUSTMENT_BY_CLIENT_ID + Id,
    token
  );
  return res;
};

export const UpdateUnderwritingAdjustment = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(
    Url.UPDATE_UNDERWRITING_ADJUSTMENT,
    payload,
    token
  );
  return res;
};
